
import { IKeHoachLopActionTypes } from "../../action-types/ke-hoach/IKeHoachLopActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachLopReducer } from "../../reducer-model/ke-hoach/IKeHoachLopReducer";
const iniState: IKeHoachLopReducer = {
  status: eReducerStatusBase.is_not_initialization,
  keHoachLops: [],
  idKh: 0,
  displayMode: "edit"
};
export const keHoachLopReducer = (
  state: IKeHoachLopReducer = iniState,
  action: IKeHoachLopActionTypes
): IKeHoachLopReducer => {
  switch (action.type) {
    case "KE_HOACH_LOP_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "KE_HOACH_LOP_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachLops: action.payload,
      };
    case "KE_HOACH_LOP_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "KE_HOACH_LOP_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        status: action.payload.type !== "he" ? eReducerStatusBase.is_need_reload : state.status
      }
    case "KE_HOACH_LOP_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      }
    case "KE_HOACH_LOP_SAVE_SUCCESS":
      const id_kh_lops = action.payload.map(x => x.id_kh_lop);
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachLops: [...state.keHoachLops.filter(x => !id_kh_lops.includes(x.id_kh_lop)), ...action.payload]
      }
    case "KE_HOACH_LOP_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      }
    case "KE_HOACH_LOP_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload
      }
    case "KE_HOACH_LOP_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      }
    case "KE_HOACH_LOP_DELETE_SUCCESS":
      const ids = action.payload;
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        keHoachLops: state.keHoachLops.filter(x => !ids.includes(x.id_kh_lop))
      }
    case "KE_HOACH_LOP_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      }
    default:
      return state;
  }
};
